import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

/**
 * Gallery section of the listing page.
 *
 * Renders gracefully with 0 images (ListingImageGallery falls back to a
 * placeholder) and with exactly 1 image (thumbnail strip and prev/next are
 * suppressed by ListingImageGallery).
 */
const SectionGallery = props => {
  const { listing, variantPrefix } = props;
  const images = listing?.images || [];
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
      />
    </section>
  );
};

export default SectionGallery;
